import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useStoreDispatch, useStoreSelector } from "../../../../../hooks/StoreHooks";
import { getCurrentUser } from "../../../../core/common_functions";
import { useDialogs } from "../../../../providers/dialogs_provider";
import { useConfigurationsService } from "../../../../services/configurations_service";
import { FormColor } from "./components/forms/frm_color";
import { FormColorType } from "./components/forms/frm_color";
import { usePergolaConfigurationBuilderActions } from "../../../../../store/reducers/pergola_configuration_builder";
import { useConfigurationsServicePergola } from "../../../../services/pergola_service";
import { AspectPergola } from "../../../../models/pergola_configuration";
import { LatoInstallation } from "./components/forms/Pergola_type";
export const AspectPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { base, pergolaConfigurationBuilder } = useStoreSelector(store => store);
  const dispatcher = useStoreDispatch();
  const currentUser = getCurrentUser(base);
  const { setStepActive, setStepComplete } = usePergolaConfigurationBuilderActions();
  const dialogs = useDialogs();
  const [isSubmit, setSubmit] = useState<boolean>(false);
  const configurationService = useConfigurationsServicePergola();
  const sceneContainerRef = useRef<HTMLDivElement>(null);
  const [colorModel, setColorModel] = useState<FormColorType>({
    coloreTelaio: pergolaConfigurationBuilder.configuration?.aspetto.colore_telaio || "9010",
    coloreLamelle: pergolaConfigurationBuilder.configuration?.aspetto.colore_lamelle || "9010"
  });

  const submit = async () => {  
    setSubmit(true);
    try {
      if (pergolaConfigurationBuilder.configuration && colorModel) {
        const data: AspectPergola = {colore_lamelle: colorModel.coloreLamelle,colore_telaio: colorModel.coloreTelaio}
        await configurationService.updateAspect(
          currentUser,
          pergolaConfigurationBuilder.configuration.configurationId,
          data
        );
      }
      dispatcher(setStepComplete({ stepSlug: "aspetto", isComplete: true }));
      const lati = pergolaConfigurationBuilder.configuration?.dimensioni.lati ?? [];
     const TOTAL_LATI = 4;
      const tuttiAddossati =
        (lati?.length ?? 0) === TOTAL_LATI &&
        lati!.every(l => l.tipo === LatoInstallation.addossato);
      if (tuttiAddossati) {
        dispatcher(setStepActive({ stepSlug: "illuminazioni", isActive: true }));
        navigate(`/pergola-configurations/${id}/illuminazioni`);
      } else {
        dispatcher(setStepActive({ stepSlug: "chiusure", isActive: true }));
        navigate(`/pergola-configurations/${id}/chiusure`);
      }
    } catch (e: any) {
      setSubmit(false);

      if (typeof e == "string") {
        dialogs?.showError("Attenzione...", e);
      } else {
        if (e.severity == "error") {
          if (e.message == "UNAVAILABLE") {
            let msg = "Siamo spiacenti";
            dialogs?.showError("Attenzione...", msg);
          } else {
            dialogs?.showError("Attenzione...", e.message);
          }
        } else if (e.severity == "warning") {
          dialogs?.showWarning("Attenzione...", e.message);
        }
      }
    }
  };

  useEffect(() => {
    if (!id || isNaN(Number(id)) || !pergolaConfigurationBuilder.configuration) {
      navigate("/configurations");
    } else {
      dispatcher(setStepActive({ stepSlug: "aspetto", isActive: true }));
    }
  }, []);

  return (
    <div className="row h-full m-0">
      <div className="row h-full m-0">
        <div>
          <div className="p-4">
            <FormColor colors={pergolaConfigurationBuilder.colors} model={colorModel} setModel={setColorModel} />

            <div className="d-flex flex-row-reverse justify-content-between mt-3">
              <Button disabled={isSubmit} variant="contained" className="ps-3 pe-1" onClick={() => submit()}>
                <span>Avanti</span>
                <NavigateNextIcon />
              </Button>

              <Button variant="contained" className="ps-1 pe-3" color="secondary" onClick={() => {
                dispatcher(setStepActive({ stepSlug: "dimensioni", isActive: true }));
                navigate(`/pergola-configurations/${pergolaConfigurationBuilder.configuration?.configurationId}/dimensioni`);
              }}>
                <NavigateBeforeIcon />
                <span>Indietro</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
